import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { MdClose, MdMenu } from "react-icons/md";
import ModuleLockedLayout from "../../platform_core/funnel/components/ModuleLockedLayout";
import { useIsModuleEnabled } from "../../platform_core/feature_flags/services/FeatureFlagService";
import ServerUnavailable from "../../platform_core/shell/components/ServerUnavailable";
import SalesSideTabs from "./SalesSideTabs";
import "./SalesLayout.scss";

export default function SalesLayout() {
  const { isEnabled, isLoading, isError, isRetrying, retry } = useIsModuleEnabled("sales");

  if (isLoading) return null;
  if (isError) return <ServerUnavailable onRetry={retry} isRetrying={isRetrying} />;

  if (!isEnabled) {
    return (
      <ModuleLockedLayout
        moduleId="sales"
        moduleName="Sales"
        fallbackDescription="Lösungen für Verkaufs- und Vertriebsprozesse"
      />
    );
  }

  return <EnabledSalesLayout />;
}

function EnabledSalesLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) setIsSidebarOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isSidebarOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previousOverflow; };
  }, [isSidebarOpen]);

  return (
    <div className={`sales-layout ${isSidebarOpen ? "sales-layout--sidebar-open" : ""}`}>
      <aside className="sales-layout__sidebar">
        <div className="sales-layout__sidebar-header">
          <button
            type="button"
            className="sales-layout__toggle"
            onClick={() => setIsSidebarOpen(false)}
            aria-label="Sales-Navigation schließen"
          >
            <MdClose />
          </button>
        </div>
        <SalesSideTabs onNavigate={() => setIsSidebarOpen(false)} />
      </aside>

      {isSidebarOpen && (
        <button
          type="button"
          className="sales-layout__overlay"
          onClick={() => setIsSidebarOpen(false)}
          aria-label="Sales-Navigation schließen"
        />
      )}

      <div className="sales-layout__main">
        <header className="sales-layout__header">
          <button
            type="button"
            className="sales-layout__toggle"
            onClick={() => setIsSidebarOpen(true)}
            aria-label="Sales-Navigation öffnen"
          >
            <MdMenu />
          </button>
        </header>
        <div className="sales-layout__content">
          <div className="sales-layout__content-main">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
